/**
 * attentionCount.ts — сколько строк рисует блок «Требует внимания» (WEB-3782).
 *
 * Одна функция на два места: подзаголовок блока (`AttentionBlock.tsx`) и
 * число у пункта «Главная» в боковом меню (`Sidebar.tsx`) — так число в меню
 * не может разойтись со строками блока. Эталон — `attCount` из
 * `design/cabinet-rescin/sections/home-x.jsx`: отказ ручки и пустой список —
 * ноль. Первая загрузка (ответа нет) — тоже ноль. Серая строка «не смогли
 * проверить» (`unchecked`) — не строка блока и в счёт не идёт.
 */
import type { AttentionData } from './useAttentionItems';

export function countAttention(
  data: AttentionData | null,
  error: unknown,
): number {
  if (error || !data) return 0;
  return data.items.length;
}
